




































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Assets from '@/constants/assets';

import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';
import Tooltip from '@/modules/shared/components/tooltip.component.vue';
import ValidationService from '@/modules/core/services/validation.service';
import numberField from '@/modules/shared/directives/number-field.directive.ts';


export enum RangeValueStyle {
  Default = '',
  Primary = 'range--primary-style',
}

@Component({
  directives: {
    numberField,
  },
  components: {
    Icon,
    Tooltip,
  },
})
export default class Range extends Vue {
  @Prop({ default: '0' }) private rangeValue!: string;
  @Prop() private rangeLabel!: string;
  @Prop({ default: false }) private readOnly!: boolean;
  @Prop({ default: '' }) private rangeError!: string;
  @Prop({ default: '' }) private rangeMeasure!: string;
  @Prop({ default: '' }) private rangePreValue!: string;
  @Prop({ default: '0' }) private rangeMinValue!: string;
  @Prop({ default: '100' }) private rangeMaxValue!: string;
  @Prop({ default: '1' }) private rangeStepValue!: string;
  @Prop({ default: '' }) private rangeInfo!: string;
  @Prop() private rangeValueStyle!: RangeValueStyle;
  @Prop({ default: '' }) private recommendedValue!: string;
  @Prop({ default: 0 }) private tabIndex!: number;


  private content: string = '';
  private isFocused: boolean = false;
  private iconEnum = IconEnum;
  private validationService = ValidationService;
  private infoHover: boolean = false;

  @Watch('rangeValue')
  private onRangeValueChanged(newVal: string, oldVal: string) {
    if (newVal !== '') {
      this.hideError();
    }
    this.content = this.rangeValue;
    this.emitInput();
  }

  private created() {
    if (this.rangeValue) {
      this.content = this.rangeValue;
      this.emitInput();
    }
  }

  get infoIcon() {
    let icon = this.iconEnum.InfoStroke;
    if (this.infoHover) {
      icon = this.iconEnum.InfoFill;
    }
    return icon;
  }

  get hasRecommendedValue() {
    return this.recommendedValue !== '';
  }

  get isRecommendedValue() {
    let isRecommended = false;
    if ( this.recommendedValue.length > 0 ) {
      const recommendedValue = Number(this.recommendedValue);
      isRecommended = ( recommendedValue > Number(this.content) );
    }
    return isRecommended;
  }

  get hasFocus() {
    return this.isFocused && !this.readOnly;
  }

  get hasContent() {
    return this.content !== '0';
  }

  get hasError() {
    return this.rangeError.length > 0;
  }

  get hasInfo() {
    return this.rangeInfo.length > 0;
  }

  get stateIcon() {
    let icon = '';
    if (this.hasContent && !this.hasError) {
      icon = this.iconEnum.Tick;
    } else if (this.hasError) {
      icon = this.iconEnum.Cross;
    }
    return icon;
  }

  get rangeMin() {
    return Number(this.rangeMinValue);
  }

  get rangeMax() {
    return Number(this.rangeMaxValue);
  }

  get hasPreValue() {
    return this.rangePreValue.length > 0;
  }

  private handleClick() {
    (this.$refs.rangeInput as HTMLInputElement).select();
    this.$emit('click');
  }

  private handleInput(e: any) {
    this.hideError();
    this.emitInput();
  }

  private emitInput() {
    this.$emit('input', this.content);
  }

  private hideError() {
    this.$emit('hide-error');
  }

  private setInfoHover(val: boolean) {
    this.infoHover = val;
  }


}
